// Payment helpers for AMC's ABC's of AI
// Talks to backend /api/payments/* endpoints and manages the local unlock flag.

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const UNLOCK_KEY = "amc_full_unlock_v1";
export const FREE_CHAPTER_IDS = ["welcome", "meet-ai", "what-is-an-app", "code-languages"];

export function isUnlocked() {
  try {
    return localStorage.getItem(UNLOCK_KEY) === "true";
  } catch (e) {
    console.warn("payments.isUnlocked: localStorage read failed", e);
    return false;
  }
}

export function markUnlocked() {
  try {
    localStorage.setItem(UNLOCK_KEY, "true");
  } catch (e) {
    console.warn("payments.markUnlocked: localStorage write failed", e);
  }
}

export function isChapterFree(chapterId) {
  return FREE_CHAPTER_IDS.includes(chapterId);
}

export async function createCheckout(packageId, customAmount = null) {
  const body = {
    package_id: packageId,
    origin_url: window.location.origin,
  };
  if (packageId === "custom" && customAmount != null) {
    body.custom_amount = Number(customAmount);
  }
  const res = await fetch(`${BACKEND}/api/payments/checkout`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Failed to start checkout");
  }
  return res.json();
}

export async function submitFeedback({ section, message, name, color }) {
  const res = await fetch(`${BACKEND}/api/feedback`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ section, message, name, color }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Failed to send feedback");
  }
  return res.json();
}

export async function fetchPaymentStatus(sessionId) {
  const res = await fetch(`${BACKEND}/api/payments/status/${sessionId}`);
  if (!res.ok) throw new Error("Failed to fetch payment status");
  return res.json();
}

// Poll payment status up to N attempts (2s interval)
export async function pollPaymentStatus(sessionId, { maxAttempts = 8, intervalMs = 2000 } = {}) {
  for (let i = 0; i < maxAttempts; i++) {
    try {
      const data = await fetchPaymentStatus(sessionId);
      if (data.payment_status === "paid") return data;
      if (data.status === "expired") return data;
    } catch (e) {
      console.warn(`payments.pollPaymentStatus attempt ${i + 1} failed`, e);
    }
    await new Promise((r) => setTimeout(r, intervalMs));
  }
  return { payment_status: "timeout" };
}
